import { GenericPortalError } from "../components/error-display/PortalError";

import { restService } from "./RestService";

class PromptService {
  async populate(config, token, projectId, documentId, instanceId) {
    const url = `${config.backendServiceURL}api/documents/${documentId}/instances/${instanceId}/prompts`;

    try {
      const res = await restService.get(url, token, projectId);

      if (res && res.ok) {
        return res.json();
      } else {
        const error = await res.json();

        throw GenericPortalError("TIMEOUT", "error", error);
      }
    } catch (e) {
      throw GenericPortalError("TIMEOUT", "error", e);
    }
  }
  async rePrompt(config, token, projectId, dossierId, instanceId) {
    try {
      const url = `${config.backendServiceURL}api/documents/${dossierId}/instances/${instanceId}/rePrompt`;
      const res = await restService.post(url, null, token, projectId);

      if (res && res.ok) {
        return res.json();
      } else {
        const error = await res.json();

        throw GenericPortalError("TIMEOUT", "error", error);
      }
    } catch (e) {
      throw GenericPortalError("TIMEOUT", "error", e);
    }
  }
  async answer(config, token, projectId, dossierId, instanceId, prompts, promptAnswers) {
    try {
      const url = `${config.backendServiceURL}api/documents/${dossierId}/instances/${instanceId}/prompts/answers`;

      promptAnswers = this.populatePromptAnswers(prompts, promptAnswers);

      const res = await restService.put(url, { prompts: promptAnswers }, token, projectId);

      if (res && res.ok) {
        return true;
      } else {
        const error = await res.json();

        throw GenericPortalError("TIMEOUT", "error", error);
      }
    } catch (e) {
      throw GenericPortalError("TIMEOUT", "error", e);
    }
  }
  async answerv2(config, token, projectId, dossierId, instanceId, prompts, promptAnswers) {
    try {
      const url = `${config.backendServiceURL}api/documents/${dossierId}/instances/${instanceId}/promptsAnswers`;

      promptAnswers = this.populatePromptAnswersv2(prompts, promptAnswers);

      const res = await restService.post(url, { answers: promptAnswers }, token, projectId);

      if (res && res.ok) {
        return true;
      } else {
        const error = await res.json();

        throw GenericPortalError("TIMEOUT", "error", error);
      }
    } catch (e) {
      throw GenericPortalError("TIMEOUT", "error", e);
    }
  }
  populatePromptAnswers(prompts, answers) {
    let promptanswers = [];

    if (answers != null && answers.length > 0) {
      prompts.forEach((prompt) => {
        let answer = this.concatAnswers(answers.filter((x) => x.id == prompt.id));

        promptanswers.push({
          key: prompt.key,
          id: prompt.id,
          name: prompt.name,
          type: prompt.type,
          answers: answer == "" ? [""] : answer,
          useDefault: false,
        });
      });
    }

    return promptanswers;
  }
  populatePromptAnswersv2(prompts, answers) {
    let promptanswers = [];

    if (answers != null && answers.length > 0) {
      prompts.forEach((prompt) => {
        let answer = this.concatAnswers(
          prompt.id,
          answers.filter((x) => x.id.find((t) => t == prompt.id) != undefined),
        );

        promptanswers.push({
          key: prompt.key,
          id: prompt.id,
          name: prompt.name,
          type: prompt.type,
          values: answer == "" ? [] : [answer],
          useDefault: false,
        });
      });
    }

    return promptanswers;
  }
  concatAnswers(idprompt, answers) {
    let text = "";

    switch (idprompt) {
      case "F4C28419437AA78AA5E7B1A1755C0B53":
        answers.forEach(function (answer) {
          text = text.concat(answer.value + " ");
        });
        break;
      case "E416727E450700611122C5AE1240A9C4": {
        const year = answers.find((t) => t.label == "Year").value;
        let month = answers.find((t) => t.label == "Month");

        month = month.elements.find((t) => t.id == month.value)?.id_int;
        text = year + month;
        break;
      }
      case "0526CBDA4A4905B8C4874995B6DE8918": // Region
        if (answers.length > 0) {
          text = answers[0].value;
        }
        break;
      case "C00F8B74478126E3E8874BB2E8FC8FC0": // Country
        if (answers.length > 0) {
          text = answers[0].value;
        }
        break;
    }

    return text.trim();
  }
  getPromptsForDashboard(dashboardId, appConfig, filterConfig) {
    let allFilters = {};
    const dashboard = appConfig.embeddedDossier.find((t) => t.id == dashboardId || t.key == dashboardId);

    if (!dashboard) return allFilters;

    dashboard.filters.forEach((filterName) => {
      if (filterName == "Date") {
        allFilters["Month"] = filterConfig[filterName]["Month"];
        allFilters["Year"] = filterConfig[filterName]["Year"];
      } else {
        allFilters[filterName] = filterConfig[filterName];
      }
    });

    return allFilters;
  }
  adaptPrompts(filters, hiddenFilters) {
    let filtersAdapted = {};

    //we review the elements to remove from filter
    Object.keys(filters).forEach((filterKey) => {
      let elementsAdapted = [];

      //iterate through elements to see which ones we should hide.
      filters[filterKey].elements.forEach((ele) => {
        if (Object.keys(ele.visibility).length > 0) {
          Object.keys(ele.visibility).forEach((visib) => {
            //if the value is "", we display all items
            //if we find it, we add the item to list.
            let eleVisibility = ele.visibility[visib];

            if (ele.id == "") {
              elementsAdapted.push(ele);

              return true;
            }
            if (
              (filters[visib].value == "" ||
                eleVisibility.find((t) => t == filters[visib].value) != undefined) &&
              this.removeHidden(filters, filterKey, ele, hiddenFilters)
            ) {
              elementsAdapted.push(ele);

              return true;
            }
          });
        } else {
          elementsAdapted.push(ele);
          //get the elements from other filters that need to be shown in order for element to be displayed
          //we look for SUR in the element Argentina.
        }
      });
      filtersAdapted[filterKey] = {
        ...filters[filterKey],
        displayedElements: elementsAdapted,
      };
    });

    return filtersAdapted;
  }

  removeHidden(filters, filterKey, element, hiddenFilters) {
    let elementshown = true;

    hiddenFilters.forEach((hiddenFilter) => {
      if (Object.values(hiddenFilter).length == 1) {
        if (filterKey == Object.keys(hiddenFilter)[0])
          elementshown = !(element.id == Object.values(hiddenFilter)[0]);
      } else {
        if (hiddenFilter[filterKey] != undefined) {
          let found = false;

          Object.keys(hiddenFilter).forEach((elemKey) => {
            if (filters[elemKey].value == hiddenFilter[elemKey]) found = true;
          });
          elementshown = !(
            found &&
            hiddenFilter[filterKey] == element.id &&
            filters[filterKey].value != element.id
          );
        }
      }
    });

    return elementshown;
  }

  getHiddenFilters(groups, hiddenSet) {
    let hiddenFilters = [];

    if (groups != undefined)
      groups.forEach((group) => {
        if (hiddenSet[group.id] != undefined) {
          hiddenFilters.push(...hiddenSet[group.id]);
        }
      });

    return hiddenFilters;
  }

  getDisplayedFiltersForDashboard(filters, currentDash, config) {
    let filt = {};
    const dashFilters = config.applications.embedding.embeddedDossier.find(
      (t) => t.id == currentDash || t.key == currentDash,
    )?.filters;

    if (!dashFilters) return filt;

    Object.keys(filters).forEach((filter) => {
      if (filter == "Month" || filter == "Year") {
        if (dashFilters.find((d) => d == "Date") != undefined) {
          filt[filter] = filters[filter];

          return;
        }
      }
      if (dashFilters.find((d) => d == filter) != undefined) {
        filt[filter] = filters[filter];

        return;
      }
    });

    return filt;
  }
}
export const promptService = new PromptService();
